import { render, staticRenderFns } from "./AddLead.vue?vue&type=template&id=4b79475d&scoped=true"
import script from "./AddLead.vue?vue&type=script&lang=js"
export * from "./AddLead.vue?vue&type=script&lang=js"
import style0 from "./AddLead.vue?vue&type=style&index=0&id=4b79475d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b79475d",
  null
  
)

export default component.exports